import React, { FC, useState } from 'react'
import { Button, Checkbox, Divider, Empty, Layout, Modal, Row, Table, Tabs, Typography } from 'antd'
import { SettingOutlined } from "@ant-design/icons"
import { defaultColumns } from '../models/miscellaneous/MiscellaneousStatDefaultColumns'
import { columns } from '../models/miscellaneous/MiscellaneousStatColumns'
import { HeaderText } from './common/HeaderText'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'

const { Group } = Checkbox
const { Header, Content } = Layout
const { Text } = Typography
const { TabPane } = Tabs

const displayColumnOptionsCheckBox = (defaultColumns: Array<any>) => {
    const options: Array<any> = [];

    defaultColumns.forEach((column) => {
        const title = column["title"]
        if (title !== "Name") {
            options.push(
                title
            )
        }
    })
    return options;
}

export interface MiscellaneousStatsProps {
    matches?: Array<any>
    totalStats: Array<any>
}

export const MiscellaneousStats: FC<MiscellaneousStatsProps> = (props) => {
    const [isColumnSettingModalVisible, setIsColumnSettingModalVisible] = useState<boolean>(false)
    const [columnSettings, setColumnSettings] = useState<Array<any>>(defaultColumns)

    const handleColumnSettingClick = () => {
        setIsColumnSettingModalVisible(true)
    }

    const handleColumnSettingModalCancel = () => {
        setIsColumnSettingModalVisible(false)
    }

    const handleColumnSettingModalOk = () => {
        setIsColumnSettingModalVisible(false)
    }

    const displayMatchTabs = (matches: Array<any>) => {
        if (matches.length === 0) {
            return (
                <TabPane tab={"No matches found."} key={"N/A"}>
                    <Empty description={"No matches found."} />
                </TabPane>
            )
        }

        const matchTabs = matches.sort((a, b) => a.matchnumber - b.matchnumber).map((match) => {
            var matchLabel;
            if (match.matchname === '' || match.matchname === undefined) {
                matchLabel = "Match"
            } else {
                matchLabel = match.matchname
            }

            return (
                <TabPane tab={`#${match.matchnumber} - ${matchLabel} [${match.mapname}]`} key={match.matchnumber}>
                    <Table columns={columnSettings} dataSource={JSON.parse(match.matchstats)} scroll={{ y: 800 }} pagination={false} />
                </TabPane>
            )
        })
        const totalStats = displayTotal(columnSettings)
        matchTabs.unshift(totalStats)

        return matchTabs
    }

    const displayTotal = (columnDefinitions: Array<any>) => {
        if (props.totalStats.length === 0) {
            return (
                <TabPane tab={"Total"} key="total">
                    <Empty style={{ minWidth: "calc(100vw - 10%)" }} />
                </TabPane>
            )
        } else {
            return (
                <TabPane tab={"Total"} key="total" >
                    <Table columns={columnDefinitions} dataSource={props.totalStats} scroll={{ y: 800 }} pagination={false} />
                </TabPane>
            )
        }
    }

    function handleColumnSelectCheckBox(selectedColumns: Array<CheckboxValueType>) {
        const displayColumns: Array<any> = [];
        displayColumns.push({
            title: "Name",
            dataIndex: "name",
            key: "name",
            sorter: {
                compare: (a: any, b: any) => a.name.localeCompare(b.name),
            },
            defaultSortOrder: "ascend"
        })
        columns.forEach((column) => {
            if (selectedColumns.includes(column.title)) {
                displayColumns.push(column)
            }
        })
        setColumnSettings(displayColumns)
    }

    return (
        <>
            <Layout>
                <Header>
                    <Row justify="space-between" align="middle" >
                        <HeaderText title={"Miscellaneous Stats"} />
                        <Button icon={<SettingOutlined />} size="large" onClick={handleColumnSettingClick}>Column Settings</Button>
                    </Row>
                </Header>
                <Divider />
                <Content>
                    <Tabs>
                        {displayMatchTabs(props.matches || [])}
                    </Tabs>
                </Content>
            </Layout>
            <Modal
                visible={isColumnSettingModalVisible}
                title={"Select Miscellaneous Stats to View"}
                bodyStyle={{ height: 600 }}
                width={1024}
                onCancel={handleColumnSettingModalCancel}
                onOk={handleColumnSettingModalOk}>
                <Text strong style={{ fontSize: 24 }}>Selected</Text>
                <Divider />
                <Group options={displayColumnOptionsCheckBox(columns)} defaultValue={displayColumnOptionsCheckBox(defaultColumns)} onChange={(newValue) => { handleColumnSelectCheckBox(newValue) }} />
            </Modal>
        </>
    )
}